import { useState } from "react";
import { DownCaret } from "../Icons/Carets";




export type CheckCategory = {

    name:string,
    id:string
    items:{name:string,checked:boolean,id:string,saveID?:string,misc?:any}[]
    isCollapsed?:boolean
    misc?:any

}

export enum CategoryFilterStatus{
    None = 0,
    All = 1,
    Some = 2

}

export type CategoryFilterData = {
    included:string[];
    id:string;
    status:number;
    
}

export type ClassCategoryFilterData = {
    included:string[];
    excluded:string[];
}





export function CategorySelector( {sticky,catagories,onUpdate,useAmbiguous,includeIds}:{catagories : CheckCategory[],sticky?:boolean,onUpdate:(cats:CheckCategory[])=>void,useAmbiguous?:boolean,includeIds?:boolean}){

    const [toggleState,setToggleState] = useState(false);
   
    const onUpdateSelections = ()=>{
        onUpdate(catagories);
    }

    const setAll = (checked:boolean)=>{

        for(let i = 0;i<catagories.length;i++){
            for(let j = 0;j<catagories[i].items.length;j++){
                catagories[i].items[j].checked = checked;
            }
        }

        onUpdateSelections();
        setToggleState(!toggleState);

    }


    function RenderCategoryBox({category,filter,onUpdateSelections}:{category:CheckCategory,filter?:string,onUpdateSelections?:()=>void}){
            
   
          
            const [toggleState,setToggleState] = useState(false);
            const checkOrUncheckAll = ()=>{

                let allChecked = true;
                for(let i = 0;i<category.items.length;i++){
                    if(!category.items[i].checked){
                        allChecked = false;
                        break;
                    }
                }

                for(let i = 0;i<category.items.length;i++){
                    category.items[i].checked = !allChecked;
                }


                setToggleState(!toggleState);
                onUpdateSelections&&onUpdateSelections();
            }

            const getCategoryState = ()=>{
                let checkedCount = 0;

                for(let i = 0;i<category.items.length;i++){
                    if(category.items[i].checked){
                        checkedCount++;
                    }
                }

                if(checkedCount==0){
                    return 0;
                }
                else if(checkedCount==category.items.length){
                    return 1;
                }
                else{
                    if(useAmbiguous)
                    return 2;
                else
                    return 1;
                }
            }

            let found = true;
            let filterChildren = false;

            if(filter){
                found = false;

                if(category.name.toLowerCase().includes(filter.toLowerCase())){
                    found = true;
                }

                else{
                    for(let i = 0;i<category.items.length;i++){
                        if(category.items[i].name.toLowerCase().includes(filter.toLowerCase())){
                            found = true;
                            filterChildren = true;
                            break;
                        }
                    }
                }

            }

            if(!found){
                return <></>;
            }

            const showCategory = (category.name&&category.name.length>0)

           return <>
            {showCategory&&
           <div className="flex-row gap-small ellipsis" style={{height:"40px"}}>

                    <div
                    style={{cursor:"pointer",padding:"4px", fontSize:"12px",transform:(category.isCollapsed?"rotate(-90deg)":"rotate(0deg)"),transition:"transform .2s "}}
                    onClick={()=>{category.isCollapsed = !category.isCollapsed;  setToggleState(!toggleState)}}
                    ><DownCaret /></div>
                    <div className="flex-row gap-med cursor-pointer" style={{paddingLeft:"4px"}} onClick={checkOrUncheckAll}>
                    <AmbiguousCheckSelect checkState={getCategoryState()} />
                    <span className="max-100 ellipsis" style={{maxWidth:"170px"}}>{category.name}</span>
                    </div>
                    </div>}

            {!category.isCollapsed&&<div className="flex-column " style={{paddingLeft:(showCategory?"46px":"24px")}}>


                {category.items.map((item,i)=>{

                    if(filterChildren&&filter&&!item.name.toLowerCase().includes(filter.toLowerCase())){
                        return null;
                    }


                    return <CheckItem key={i} item={item.name} checked={item.checked} 
                    inId={"check-"+item.id}
                    onClickFunc={()=>{
                        item.checked = !item.checked; 
                        setToggleState(!toggleState); 
                        onUpdateSelections&&onUpdateSelections();
                    }}
                    />
                })}
                
                </div>
            }
            </>
    }

    
    const [filter,setFiler] = useState(""); 


    return <div style={sticky?{}:{margin:"16px 0px 0px 0px"}} >
                <div style={{background:"white",borderRadius:"4px",boxShadow:"0 0 10px 10px #00000005"}}>
                    <div style={sticky?{background:"white",position:"sticky",top:"0",zIndex:5}:{}}>
                    <div className="flex-column gap-med w-full " style={{background:"#F8F8F8",padding:"8px",fontSize:"15px"}}>
                
                        <div className="flex-row justify-between w-full" >
                            <button className="invisible-button" onClick={(e)=>{e.preventDefault();setAll(true)}}>Select All</button>
                            <button className="invisible-button" onClick={(e)=>{e.preventDefault();setAll(false)}}>Select None</button>
                        </div>

                    </div>
                    <div className="relative  wb-input-group" style={{padding:"8px"}}>
                            <input id="category-filter-input" style={{paddingLeft:"30px"}} className="w-full " placeholder="Search" type="text" onInput={(e)=>setFiler((e.target as any).value)} />
                            <SearchIcon/>
                        </div>
                        </div>
                    <div className="flex-column check-selector" style={{fontWeight:"normal",padding:"8px 14px"}}>
        
                    {catagories.map((category,i)=>{
                        return <RenderCategoryBox key={i} category={category} filter={filter} onUpdateSelections={onUpdateSelections} />
                    })}
                    </div>
            </div>
        </div>
}


export function CheckItem({item,checked,onClickFunc,styling,inId}:{inId?:string,item:string,checked:boolean,onClickFunc:(e:any)=>void,styling?:any}){

    const style = styling??{height:"40px"};

    return <div id={inId??""} className="flex-row gap-med cursor-pointer "  style={style} onClick={ onClickFunc}>
        <AmbiguousCheckSelect checkState={(checked?1:0)} />
        <span className="max-100 ellipsis">{item}</span>
    </div>
}
export function AmbiguousCheckSelect({checkState}:{checkState:CategoryFilterStatus}){


    return <div style={{cursor:"pointer", width:"18px",height:"18px",border:"1px solid #CDCDCD",flexShrink:"0",borderRadius:"5px",background:(checkState==0?"white":"#333")}} className='center-all'>
        {
            checkState==CategoryFilterStatus.All&&<svg xmlns="http://www.w3.org/2000/svg" height=".8em" viewBox="0 0 448 512" fill="white"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>
        }
        {
            checkState==CategoryFilterStatus.Some&&<svg xmlns="http://www.w3.org/2000/svg" height=".8em" fill="white" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
        }

    </div>

}

function SearchIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" height="1em" width={"1em"} viewBox="0 0 512 512" fill="#9A9A9A" style={{ position: "absolute", left: "16px", top: "20px", pointerEvents: "none" }}><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" /></svg>
}